import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
AgendaService,
DayService,
MonthAgendaService,MonthService,
ScheduleModule,WeekService,
WorkWeekService
} from '@syncfusion/ej2-angular-schedule';
import { SimplebarAngularModule } from 'simplebar-angular';
import { NewVacationModule } from '../dave-employee-administration-module/components/vacation/new-vacation/new-vacation.module';
import { DaveLoadingModule } from '../dave-loading/dave-loading.module';
import { SelectSearchModule } from '../dave-utils-module/select-search/select-search.module';
import { JobSpecificationOptionComponent } from '../job-specification-option/job-specification-option.component';
import { AppButtonModule } from './../dave-utils-module/app-button-module/app-button.module';
import { AppFilterModule } from './../dave-utils-module/app-filter-module/app-filter.module';
import {
ResourcePlanDialogComponent
} from "./components/resource-plan/resource-plan-dialog/resource-plan-dialog.component";
import { ResourcePlanComponent } from './components/resource-plan/resource-plan.component';
import { ShiftPlanDialogComponent } from './components/shift-plan/shift-plan-dialog/shift-plan-dialog.component';
import { ShiftPlanComponent } from './components/shift-plan/shift-plan.component';
import { DaveCalendarRoutingModule } from './dave-calendar-routing.module';

@NgModule({
    declarations: [ShiftPlanComponent, ShiftPlanDialogComponent, ResourcePlanComponent, ResourcePlanDialogComponent],
    imports: [
        CommonModule,
        DaveCalendarRoutingModule,
        MatMenuModule,
        FontAwesomeModule,
        MatButtonToggleModule,
        SimplebarAngularModule,
        AppFilterModule,
        MatCardModule,
        MatSidenavModule,
        AppButtonModule,
        MatTooltipModule,
        MatBadgeModule,
        MatButtonModule,
        MatIconModule,
        ScheduleModule,
        RouterModule,
        DaveLoadingModule,
        JobSpecificationOptionComponent,
        MatFormFieldModule,
        MatOptionModule,
        MatSelectModule,
        ReactiveFormsModule,
        SelectSearchModule,
        NewVacationModule,
    ],
    exports: [ShiftPlanComponent, ResourcePlanComponent],
    providers: [DayService, WeekService, WorkWeekService, MonthService, AgendaService, MonthAgendaService],
})
export class DaveCalendarModule {}
